jQuery(document).ready(function(){

    popUp.init();
    loadMorePosts.init();
    utility.init();



    // Mobile Menu

    jQuery('#mobile-menu').click(function(){

  		jQuery('header').toggleClass('mobile-active');

  		if(jQuery('header').hasClass('mobile-active')) {
  			jQuery('body, html').css('overflow-y', 'hidden');
  		} else {
  			jQuery('body, html').css('overflow-y', 'auto');
  		}
  	});

    var itemHasChildren = jQuery('.menu-item-has-children');

    itemHasChildren.click(function () {
      jQuery(this).toggleClass('active');
    });


    // Header Scroll

    jQuery(window).scroll(function(event){
      var yOffset = window.pageYOffset;
      var breakpoint = jQuery('header').outerHeight();

      if (yOffset > breakpoint - 90){
        jQuery("header").addClass('active');
      }else{
        jQuery("header").removeClass('active');
      }
    });

    // Subscribe Popup

    jQuery('.newsletter-popup form').each(function() {
        var form = jQuery(this)

        jQuery('input[type="submit"]').click(function(e) {
          e.preventDefault();
          var button = jQuery(this)

          if(!button.hasClass('active')) {
            button.addClass('active');
            jQuery('.newsletter-popup').addClass('popup-active');
          } else {
            form.submit()
          }
        })

        jQuery('.popup-close').click(function() {
          jQuery('.newsletter-popup form input[type="submit"]').removeClass('active');
          jQuery('.newsletter-popup').removeClass('popup-active');
        });

    });
});

// Slider

jQuery(window).load(function(){
    jQuery('.slider').flickity({
        autoPlay: 8000,
        prevNextButtons: true,
        imagesLoaded: true,
        pageDots: true,
        setGallerySize: true,
        wrapAround: true,
    });

    jQuery('.activity-slider').addClass('active');
});

// Popup

var popUp = {
    init: function() {
        jQuery('.button-popup').click(function() {
            jQuery('.popup').addClass('active');
            jQuery('body').css('overflow-y', 'hidden');
        });

        jQuery(document).keyup(function(e) {
             if (e.keyCode == 27) {
                popUp.popupClose();
            }
        });
    },

    popupClose: function() {
        jQuery('.popup').removeClass('active');
        jQuery('body').css('overflow-y', 'auto');
    }
}


// Load More Posts

var loadMorePosts = {
		init: function() {
				jQuery('#load-more-posts').click(function(){
						loadMorePosts.loadMore();
				});
		},

		loadMore: function() {
			var loadContainer = jQuery('#load-container');
			var postCount = jQuery('#load-container .post-thumbnail').length;
			var totalPosts = loadContainer.data('total');

			if(postCount >= totalPosts) {
				return;
			}

			var data = {
					action: 'load_more_posts',
					post_count: postCount,
					post_search: posts.s,
					current_taxonomy: posts.current_taxonomy,
					current_term: posts.current_term,
					current_child_term: posts.current_child_term,
			};

			jQuery.ajax({
				url: posts.ajaxurl,
				type: "POST",
				data: data,
				beforeSend: function () {

					// Request for posts

					jQuery('#load-more-posts').addClass('loading');
				},
				complete: function () {

					// Request for posts received / response is being sent back to us

					jQuery('#load-more-posts').removeClass('loading');
				},
				success: function(data) {

					// We get posts back / successful response

					if(data) {
							loadContainer.append(data);
					}

					postCount = jQuery('#load-container .post-thumbnail').length;

					if(postCount >= totalPosts) {
							jQuery('#load-more-posts').replaceWith('<a class="no-posts" href="#load-container">Back to top</a>');
					}

					utility.hashAnimate();

					return;
				}
			});
		}
}

var utility = {
    init: function() {
        utility.hashAnimate();
    },

    hashAnimate: function() {
        jQuery('*[href*=#]').click(function(e) {
            e.preventDefault();

            var localHash = jQuery(this).attr('href');
            var scrollOffset = jQuery('header').outerHeight();



            jQuery("html, body").animate({
                scrollTop: jQuery(localHash).offset().top - scrollOffset - 80
            }, 200);
        });
    }
}
